import PageSet from '@linc-technologies/linced-common/models/posts/page-set';
import type { Type } from '@warp-drive/core/types/symbols';
import { hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import type Page from 'linced-admin/models/posts/page';

// linced-admin replaces posts/page with its own model, which has no
// `pageSetIds` relationship, so pages has no inverse here. linced-common
// declares inverse: 'pageSetIds' to pair with the shared posts/page; this
// override keeps that from asserting in this app, and matches the inverse
// EmberData already auto-detects for linced-admin today.
export default class _PageSet extends PageSet {
  declare [Type]: 'posts/page-set';

  @hasMany('posts/page', { async: true, inverse: null })
  // @ts-expect-error the linced-admin posts/page is posts.PageTemplate, not the
  // common Page.
  declare pages: AsyncHasMany<Page>;
}
